import React, { useState } from "react";
import { useNavigate } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import { UniversalImg5, EyeCloseIcon, EyeOpenIcon } from "../../Constant/Index";

const NewPassword = () => {
    const [passwordStates, setPasswordStates] = useState([]);

    const togglePasswordVisibility = (index) => {
        setPasswordStates((prevStates) => {
            const newStates = [...prevStates];
            newStates[index] = !newStates[index];
            return newStates;
        });
    };
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/signin');
    };
    return (
        <>
            <Header />
            <UniversalBanner heading="Forgot Password" />
            <section className="auth-section">
                <div className="container">
                    <div className="auth-start">
                        <div className="row">
                            <div className="col-lg-7 col-md-6 order-1 order-md-0 mt-5 mt-md-0">
                                <div className="row">
                                    <div className="col-xl-2 col-lg-1"></div>
                                    <div className="col-xl-7 col-lg-8 px-xl-0">
                                        <div className="form-area">
                                            <h2 className="md-heading pb-1 mb-4">Create New Password</h2>
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-4">
                                                        <div className="form-group password">
                                                            <input type={passwordStates[0] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="New Password" />
                                                            <button className="show-password" type="button" onClick={() => togglePasswordVisibility(0)}>
                                                                <img src={passwordStates[0] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-4">
                                                        <div className="form-group password">
                                                            <input type={passwordStates[1] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Confirm Password" />
                                                            <button className="show-password" type="button" onClick={() => togglePasswordVisibility(1)}>
                                                                <img src={passwordStates[1] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-4">
                                                        <div className="form-submit">
                                                            <button type="submit" className="btn d-block w-100">Send</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6">
                                <figure className="with-bg with-hover">
                                    <img src={UniversalImg5} className="auth-img w-100 with-boxes with-raduis" alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    )
}
export default NewPassword;